<!-- 选择器，主栏目 -->
<template>
  <div class="permissionbox">
    <el-card class="permissionbox__active_permission">
      <div slot="header" class="clearfix">
        <span>当前使用的许可</span>
      </div>
      <div class="permissionbox__active_permission__group">
        <template v-for="item in activesDatas">
          <div class="permissionbox__active_permission__item" :key="item.id">
            <el-tag
              closable
              :type="getComponentType(item.type)"
              :key="item.id"
              @close="closeTag(item)"
            >{{item.content}}</el-tag>
          </div>
        </template>
      </div>
    </el-card>

    <el-divider content-position="left">
      <i class="el-icon-s-custom"></i>
    </el-divider>

    <div class="permissionbox__list">
      <el-collapse v-model="activeName" accordion>
        <template v-for="item in datas">
          <el-collapse-item :title="item.title" :name="item.id" :key="item.id">
            <template v-for="it in item.datas">
              <div class="permissionbox__item" :key="it.id">
                <div class="permissionbox__item__tool">
                  <el-button
                    :type="getComponentType(it.type)"
                    size="mini"
                    icon="el-icon-circle-plus-outline"
                    v-if="!it.rpid"
                    @click="add(it)"
                  >添加</el-button>
                  <el-button
                    :type="getComponentType(it.type)"
                    size="mini"
                    icon="el-icon-check"
                    disabled
                    plain
                    v-if="it.rpid"
                  >已添加</el-button>
                </div>
                <div class="permissionbox__item__content">{{it.content}}</div>
              </div>
            </template>
          </el-collapse-item>
        </template>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import { getListApi } from "@/api/module/role/permission.js";

export default {
  name: "permissionbox",
  props: {},
  data() {
    return {
      cid: null,
      datas: [],
      activesDatas: [],
      activeName: 0,
      loading: false,
    };
  },
  methods: {
    init() {
      var _this = this;

      // console.log("this.cid : " + this.cid);

      let params = {
        cid: this.cid,
      };

      getListApi(params)
        .then((result) => {
          _this.datas = result.datas;

          _this.activesDatas = new Array();

          // _this.activesDatas = result.datas;
          for (let i = 0; i < _this.datas.length; i++) {
            let items = _this.datas[i].datas;
            for (let j = 0; j < items.length; j++) {
              let item = items[j];
              if (item.rpid) {
                _this.activesDatas.push(item);
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          _this.exportsOnUpdate();
        });
    },
    // 添加许可
    add(item) {
      var _this = this;
      item.rpid = "11";
      _this.activesDatas.push(item);

      this.exportsOnUpdate();
    },

    closeTag(item) {
      var _this = this;
      let index = _this.activesDatas.indexOf(item);
      _this.activesDatas.splice(index, 1);

      for (let index in _this.datas) {
        let data = _this.datas[index];

        data.datas.forEach((d) => {
          if (d.id == item.id) {
            d.rpid = null;
          }
        });
      }

      this.exportsOnUpdate();
    },

    getComponentType(type) {
      if (type == 0) {
        return "success";
      } else if (type == 1) {
        return "primary";
      } else if (type == 2) {
        return "warning";
      } else if (type == 3) {
        return "danger";
      } else {
        return "info";
      }
    },

    doUpdate(item) {
      this.cid = item;
      this.init();
    },

    exportsOnUpdate() {
      let ary = new Array();
      this.activesDatas.forEach((item) => {
        ary.push(item.id);
      });
      this.$emit("OnUpdate", ary);
    },
  },
  mounted: function () {
    // this.id = this.cid;
  },
  beforeMount: function () {
    this.init();
  },
  watch: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.permissionbox {
  min-width: 400px;
}

.permissionbox__item {
  margin-top: 5px;
  margin-bottom: 5px;
  padding: 5px 10px;

  display: flex;
  flex-wrap: nowrap; // 换行 nowrap | wrap | wrap-reverse
  flex-direction: row; //| row-reverse | column | column-reverse;
  justify-content: flex-start; // 定义了项目在主轴上的对齐方式 flex-start | flex-end | center | space-between | space-around;
  align-items: flex-start; // | flex-end | center | baseline | stretch;
  transition: background-color 0.15s linear;

  .permissionbox__item__tool {
    margin-right: 5px;
  }

  .permissionbox__item__content {
    color: #606266;
  }

  &:hover {
    background-color: #EBEEF5;
  }
}

.permissionbox__active_permission__item {
  margin-bottom: 5px;

  > p {
    font-size: 14px;
    font-weight: bold;
  }

  > .el-tag {
    margin-right: 5px;
  }
}
.permissionbox__active_permission__group {
  display: flex;
  flex-wrap: wrap; // 换行 nowrap | wrap | wrap-reverse
  flex-direction: row; //| row-reverse | column | column-reverse;
  justify-content: flex-start; // 定义了项目在主轴上的对齐方式 flex-start | flex-end | center | space-between | space-around;
  align-items: flex-start; // | flex-end | center | baseline | stretch;
}
</style>
